import { Injectable } from '@angular/core';
import { GenericAkitaHTTPService, HttpOptions } from '../../service/generic-akita-http.service';
import { HttpClient } from '@angular/common/http';
import { NetworkService } from '../../service/network.service';
import { CrowdFlowROI } from '../../model/crowd-flow-roi';

@Injectable({
  providedIn: 'root'
})
export class AkitaHTTPCrowdFlowROIService extends GenericAkitaHTTPService<CrowdFlowROI> {
  constructor(http: HttpClient, networkService: NetworkService) {
    const options: HttpOptions = {
      params: {
        type: 'CrowdFlowROI',
        options: 'keyValues',
        limit: '50'
      }
    };
    super(http, networkService, '/v2/entities/', 'CrowdFlowROI', options);
  }
}
